import { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { Route, Routes, useNavigate } from "react-router-dom";
import Modal from "react-modal";
import { ClipLoader } from "react-spinners";
import { Auth, API, graphqlOperation, Storage } from "aws-amplify";

Modal.setAppElement("#root");

const SignInAndLaunchStudio = ({
  setShowModalForSignIn,
  setIsUserLoggedIn,
}) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [pwd, setPwd] = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");

  const [signInView, setSignInView] = useState("signin");

  const [errorx, setErrorx] = useState("");

  const [verificationCode, setVerificationCode] = useState("");

  /**Modals */
  const [showRotatingCircleModal, setShowRotatingCircleModal] = useState(false);
  // const [ msgWhenLoading, setMsgWhenLoading ] = useState("sdf")

  const createAccount = async () => {
    let test_if_gmail = username.match(/@gmail\.com$/);

    if (test_if_gmail === null) {
      return;
    }

    if (
      window.location.origin.includes("ion") === false ||
      window.location.origin.includes("zen") === false ||
      window.location.origin.includes("en") === false ||
      window.location.origin.includes("eno") === false ||
      window.location.origin.includes("nov") === false ||
      window.location.origin.includes("vat") === false
    ) {
      return;
    }

    if (pwd !== confirmPwd) {
      setErrorx("ERROR: Passwords not equal");
      return;
    }

    if (
      username === "" ||
      pwd === "" ||
      confirmPwd === "" ||
      username === null ||
      username === undefined
    ) {
      setErrorx("ERROR: Field cannot be blank");
      return;
    }

    setShowRotatingCircleModal(true);

    try {
      await Auth.signUp({
        username: username,
        email: username,
        password: pwd,
      });
      setErrorx("");
      setSignInView("confirmcode");
      setShowRotatingCircleModal(false);
    } catch (e) {
      setErrorx("ERROR: Some error occured");
      setShowRotatingCircleModal(false);
    }
  };

  const resetUserPassword = async () => {
    // console.log(username)
    // console.log(pwd)
    // console.log(confirmPwd)
    // return
    if (!verificationCode || !pwd || verificationCode === "" || pwd === "") {
      setErrorx("ERROR: Incorrect code or password");
      return;
    }

    if (pwd !== confirmPwd) {
      setErrorx("ERROR: Passwords dont match");
      return;
    }

    setShowRotatingCircleModal(true);
    try {
      // let user = await Auth.currentAuthenticatedUser()
      // await Auth.changePassword(user, currentPwd, newPwd);
      await Auth.forgotPasswordSubmit(username, verificationCode, confirmPwd);
      setErrorx(false);
      setPwd("");
      setConfirmPwd("");
      setUsername("");
      setSignInView("signin");
      setShowRotatingCircleModal(false);
    } catch (err) {
      setErrorx(true);
      setShowRotatingCircleModal(false);
    }
  };

  const signIntoStudio = async () => {
    if (
      window.location.origin.includes("ion") === false ||
      window.location.origin.includes("zen") === false ||
      window.location.origin.includes("en") === false ||
      window.location.origin.includes("eno") === false ||
      window.location.origin.includes("nov") === false ||
      window.location.origin.includes("vat") === false
    ) {
      return;
    }

    setShowRotatingCircleModal(true);
    try {
      let res = await Auth.signIn(username, pwd);

      // console.log(" ====== aaaa =====")
      // console.log(res)
      // return

      // navigate("/");
      setShowRotatingCircleModal(false);
      setShowModalForSignIn(false);
      setIsUserLoggedIn(true);

      setErrorx("");
    } catch (e) {
      setErrorx("ERROR: Some error occured during sign-in");
      setShowRotatingCircleModal(false);
    }

    // Add dummy entry in sssusertable -
    let idPoolUserID = await Auth.currentUserCredentials({
      bypassCache: true,
    });
    let uniqueUserId = idPoolUserID.identityId.split(":")[1];

    if (!uniqueUserId) {
      return;
    }

    const addUser = `mutation MyMutation {
      createSsssusertable(input: {uniqueId: "${uniqueUserId}", ac: "${username}", aa: "xx", dateOfBirthDay: 0, phoneNumberOne: "NA", dateOfBirthMonth: 0, 			dateOfBirthYear: 0, isVerified: "NA", fullName: "NA"}) {
        aa
        }
        }`;

    try {
      await API.graphql(graphqlOperation(addUser));
    } catch (err) {
      // IGNORE IGNORE IGNORE
      // IGNOREEEEEE exception as the user might be logging 2nd or 3rd time
      // and their entry might already be present
      // alert("Error 104. Couldn't add user")
    }
  };

  const sendForgotPasswordCode = async () => {
    if (username === "" || username === null || username === undefined) {
      setErrorx("ERROR: E-Mail can't be blank");
      return;
    }

    setShowRotatingCircleModal(true);

    try {
      await Auth.forgotPassword(username);
      setShowRotatingCircleModal(false);
    } catch (error) {
      setErrorx("ERROR: Some error occured");
      setShowRotatingCircleModal(false);
    }
  };

  const verifyEmailCode = async () => {
    if (
      window.location.origin.includes("ion") === false ||
      window.location.origin.includes("zen") === false ||
      window.location.origin.includes("en") === false ||
      window.location.origin.includes("eno") === false ||
      window.location.origin.includes("nov") === false ||
      window.location.origin.includes("vat") === false
    ) {
      return;
    }

    setShowRotatingCircleModal(true);
    try {
      await Auth.confirmSignUp(username, verificationCode);

      // code reaches here only if there is successful email code verification
      await Auth.signIn(username, pwd);

      // navigate("/");
      // setShowModalForSignIn(false);
      // setShowRotatingCircleModal(false);
      setShowRotatingCircleModal(false);
      setShowModalForSignIn(false);
      setIsUserLoggedIn(true);
      setErrorx("");

      // Add dummy entry in sssusertable -
      let idPoolUserID = await Auth.currentUserCredentials({
        bypassCache: true,
      });
      let uniqueUserId = idPoolUserID.identityId.split(":")[1];

      if (!uniqueUserId) {
        return;
      }

      const addUser = `mutation MyMutation {
      createSsssusertable(input: {uniqueId: "${uniqueUserId}", ac: "${username}", aa: "xx", dateOfBirthDay: 0, phoneNumberOne: "NA", dateOfBirthMonth: 0, 			dateOfBirthYear: 0, isVerified: "NA", fullName: "NA"}) {
        aa
        }
        }`;

      try {
        await API.graphql(graphqlOperation(addUser));
      } catch (err) {
        // IGNORE IGNORE IGNORE
        // IGNOREEEEEE exception as the user might be logging 2nd or 3rd time
        // and their entry might already be present
        // alert("Error 104. Couldn't add user")
      }
    } catch (error) {
      setErrorx("ERROR: Some error occured");
      setShowRotatingCircleModal(false);
    }
  };

  return (
    <div style={{ height: "100%", borderRadius: 44 }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          height: "7%",
        }}
      >
        {signInView === "signin" ? (
          <h4 style={{ margin: "0px" }}>
            LOG IN TO WATCH COURSE TUTORIALS (कोर्स देखने के लिए ई-मेल से लॉग इन
            करें)
          </h4>
        ) : (
          <></>
        )}
        {signInView === "createaccount" ? (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <h4 style={{ margin: "0px" }}>CREATE NEW ACCOUNT</h4>
            <h5 style={{ margin: "0px" }}>
              Kindly register with your gmail address
            </h5>
          </div>
        ) : (
          <></>
        )}
        {signInView === "confirmcode" ? (
          <div style={{ display: "flex", flexDirection: "column" }}>
            {/* <h4 style={{ margin: "0px", color: "white" }}>VERIFY CODE</h4> */}
            <p style={{ margin: "0px" }}>
              A verification code has been sent to your email address {username}
              . Please check your email and verify code. Check your inbox and
              spam/ junk folder also.{" "}
            </p>
          </div>
        ) : (
          <></>
        )}

        {signInView === "forgotpassword" ? (
          <div style={{ display: "flex", flexDirection: "column" }}>
            {/* <h4 style={{ margin: "0px", color: "white" }}>VERIFY CODE</h4> */}
            {/* <p style={{ margin: "0px" }}>
              A confirmation code will be sent to your registered e-mail
              address. Check your inbox and spam folder for a mail from admin,
              zenfura.{" "}
            </p> */}
            <p style={{ margin: "0px", fontSize: "13px" }}>
              First, enter your registered e-mail and click 'SEND CODE'. Then
              you will receive a mail from xxx. Check your
              inbox, junk or spam folder. Second, from this e-mail message, note
              the reset code and enter it here. Also, choose new password. Then
              click 'RESET PASSWORD'
            </p>
          </div>
        ) : (
          <></>
        )}

        <IoMdClose
          color="black"
          size="30px"
          onClick={() => setShowModalForSignIn(false)}
        />
      </div>
      <p style={{ color: "#782E12", margin: "0px", fontWeight: "bold" }}>
        {errorx}
      </p>

      <Modal
        isOpen={showRotatingCircleModal}
        // onRequestClose={() => setShowModal(false)}
        style={{
          overlay: {
            zIndex: 99020,
            width: "50%",
            height: "50%",
            marginLeft: "25%",
            marginTop: "10%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0)",
          },
          content: {
            backgroundColor: "rgba(255, 255, 255, 1)",
          },
        }}
      >
        <div
          style={{
            flex: 1,
            height: "100%",
            display: "flex",
            // backgroundColor: "red",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <ClipLoader
            loading
            size={"53px"}
            color="black"
            width={"100%"}
            cssOverride={{ marginTop: 0 }}
          />
          <h4>Please wait do not press any button</h4>
        </div>
      </Modal>

      {/** show only during sign in on create ne account */}
      {signInView !== "confirmcode" ? (
        <p style={{ margin: "2px", marginBottom: "4px" }}>
          E Mail (Username):{" "}
        </p>
      ) : (
        <></>
      )}

      {/** show only during sign in on create new account */}
      {signInView !== "confirmcode" ? (
        <input
          style={{ width: "40%" }}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
      ) : (
        <></>
      )}

      {/** Displayed when the user clicks forgot password */}
      {signInView === "forgotpassword" ? (
        <div
          style={{
            width: "40%",
            height: "10%",
            // backgroundColor: "#392E2E",
            backgroundColor: "#17324a",
            marginTop: "15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderWidth: 5,
            borderColor: "white",
          }}
          onClick={() => {
            sendForgotPasswordCode();

            // setErrorx("");
          }}
        >
          <p style={{ color: "white", fontWeight: "bold", margin: 0 }}>
            SEND CODE{" "}
          </p>
        </div>
      ) : (
        <></>
      )}

      {/** show only during sign in on create new account */}
      {signInView !== "confirmcode" && signInView !== "forgotpassword" ? (
        <p style={{ marginBottom: "4px" }}>Password: </p>
      ) : (
        <></>
      )}

      {signInView === "forgotpassword" ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            margin: "4px",
          }}
        >
          <p style={{ marginBottom: "4px", width: "20%" }}>Enter Code: </p>
          <input
            style={{ width: "40%" }}
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
          />
        </div>
      ) : (
        <></>
      )}

      {/** When in forgot password view */}
      {signInView === "forgotpassword" ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            margin: "4px",
          }}
        >
          <p style={{ marginBottom: "4px", width: "20%" }}>
            Set New Password:{" "}
          </p>
          <input
            style={{ width: "40%" }}
            value={pwd}
            onChange={(e) => setPwd(e.target.value)}
          />
        </div>
      ) : (
        <></>
      )}

      {/** show only during sign in or create new account */}
      {signInView !== "confirmcode" && signInView !== "forgotpassword" ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            // backgroundColor: "red",
          }}
        >
          <input
            style={{ width: "40%" }}
            type={"password"}
            value={pwd}
            onChange={(e) => setPwd(e.target.value)}
          />

          {signInView === "signin" ? (
            <p
              onClick={() => {
                setSignInView("forgotpassword");
                setPwd("");
                setConfirmPwd("");
                setVerificationCode("");
              }}
              style={{
                margin: "0px",
                marginLeft: "2%",
                fontWeight: "bold",
              }}
            >
              Forgot Password ?
            </p>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <></>
      )}

      {signInView === "confirmcode" ? (
        <>
          <p style={{ marginBottom: "4px" }}>Enter Code: </p>
          <input
            style={{ width: "40%" }}
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
          />
          <div
            style={{
              width: "40%",
              height: "12%",
              // backgroundColor: "#392E2E",
              backgroundColor: "#B75959",
              marginTop: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderWidth: 5,
              borderColor: "white",
            }}
            onClick={() => {
              verifyEmailCode();
              // setErrorx("");
            }}
          >
            <p style={{ fontWeight: "bold", color: "white", margin: 0 }}>
              VERIFY CODE AND CREATE ACCOUNT{" "}
            </p>
          </div>
        </>
      ) : (
        <></>
      )}

      {signInView === "createaccount" || signInView === "forgotpassword" ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            // alignItems: "center",
            margin: "4px",
          }}
        >
          <p style={{ marginBottom: "4px", width: "20%" }}>
            Confirm Password (Minimum 6 characters):{" "}
          </p>
          <input
            style={{ width: "40%" }}
            value={confirmPwd}
            onChange={(e) => setConfirmPwd(e.target.value)}
          />
        </div>
      ) : (
        <></>
      )}

      {/** Displayed when the user clicks forgot password */}
      {signInView === "forgotpassword" ? (
        <div
          style={{
            height: "10%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "40%",
              height: "100%",
              // backgroundColor: "#392E2E",
              backgroundColor: "#17324a",
              marginTop: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderWidth: 5,
              borderColor: "white",
            }}
            onClick={() => {
              resetUserPassword();

              // setErrorx("");
            }}
          >
            <p style={{ color: "white", fontWeight: "bold", margin: 0 }}>
              RESET PASSWORD{" "}
            </p>
          </div>
          <p
            onClick={() => {
              setSignInView("signin");
              setPwd("");
              setConfirmPwd("");
              setVerificationCode("");
            }}
            style={{
              margin: "0px",
              marginLeft: "9%",
              fontWeight: "bold",
            }}
          >
            GO BACK
          </p>
        </div>
      ) : (
        <></>
      )}

      {signInView === "signin" ? (
        <>
          <div
            style={{
              width: "40%",
              height: "12%",
              // backgroundColor: "#392E2E",
              // backgroundColor: "#B75959",
              backgroundColor: "#17324a",
              // backgroundColor: 'red',
              marginTop: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderWidth: 5,
              borderColor: "white",
            }}
            onClick={signIntoStudio}
          >
            <p style={{ color: "white", fontWeight: "bold", margin: 0 }}>
              LOG IN{" "}
            </p>
          </div>
          <p style={{ fontSize: "14px", marginTop: 15 }}>
            इस वेबसाइट का उपयोग करने से पहले इसे पढ़ें Before using this website
            (ZENFURA) you are required to read the{" "}
            <a href="tnc.html" target="_blank" rel="noreferrer">
              terms and conditions
            </a>{" "}
          </p>
        </>
      ) : (
        <></>
      )}

      {signInView === "createaccount" ? (
        <div
          style={{
            height: "10%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "40%",
              height: "100%",
              // backgroundColor: "#392E2E",
              // backgroundColor: "#B75959",
              backgroundColor: "#17324a",
              marginTop: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderWidth: 5,
              borderColor: "white",
            }}
            onClick={() => createAccount()}
          >
            <p style={{ color: "white", fontWeight: "bold", margin: 0 }}>
              CREATE ACCOUNT{" "}
            </p>
          </div>
          <p
            onClick={() => {
              setSignInView("signin");
              setPwd("");
              setConfirmPwd("");
              setVerificationCode("");
            }}
            style={{
              // backgroundColor: 'red',
              marginTop: "15px",
              height: "100%",
              margin: "0px",
              marginLeft: "9%",
              fontWeight: "bold",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            GO BACK
          </p>
        </div>
      ) : (
        <></>
      )}

      {/** This is just a horizontal white line */}
      {signInView === "signin" ? (
        <div
          style={{
            backgroundColor: "black",
            height: "2px",
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "2%",
          }}
        ></div>
      ) : (
        <></>
      )}

      {signInView === "signin" ? (
        <div
          style={{
            // backgroundColor: 'green',
            height: "12%",
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "3%",
          }}
        >
          <p style={{ fontWeight: "bold", margin: 0, marginRight: "3%" }}>
            New User? Create new account. Its FREE. नए उपयोगकर्ता? नया खाता
            बनाएँ। यह मुक्त है
          </p>
          <div
            style={{
              width: "30%",
              height: "100%",
              // backgroundColor: "#392E2E",
              // backgroundColor: "#B75959",
              backgroundColor: "#17324a",
              // marginTop: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderWidth: 5,
              borderColor: "white",
              marginLeft: "1%",
            }}
            onClick={() => {
              setSignInView("createaccount");
              setPwd("");
              setUsername("");
              setErrorx("");
            }}
          >
            <p
              style={{
                color: "white",
                fontWeight: "bold",
                margin: 0,
                padding: 0,
              }}
            >
              CREATE ACCOUNT{" "}
            </p>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default SignInAndLaunchStudio;
